import { Button, Col, Form, Input, Row, Select, notification } from 'antd'
import React, { useState } from 'react'
import { api } from '../utils/Api'
import axios from 'axios'
const { Option } = Select

const ForemanModal = ({parentCallback}) => {
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [apiNotification, contextHolder] = notification.useNotification()

    const openNotification = (type, message, description) => {
        apiNotification[type]({
            message: message,
            description: description
        })
    }

    const createForeman = async (data) => {
        const user = {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phone: `+1${data.phone}`,
            address: data.address
        }

        try {
            let url = api + '/foreman' 
            const token = localStorage.getItem('token')
            axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

            const { data } =await axios.post(url, user)
            openNotification('success', 'Success', 'Foreman created')
            setLoading(false)
            const returnForeman = {
                ...user,
                foreman: data._id
            }
            parentCallback(returnForeman)

        } catch (err) {
            setLoading(false)
            openNotification('error', 'Error', 'Error while trying to create user')
            console.error(err.message)
            return null
        }
    }

    const onFinish = (values) => {
        setLoading(true)
        createForeman(values)
    }

    const prefixSelector = (
        <Form.Item name="prefix" noStyle>
          <Select
            style={{
              width: 70,
            }}
          >
            <Option value="+1">+1</Option>
          </Select>
        </Form.Item>
    )

    const CustomForm = () => {
        return <Form
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={{
                prefix: '+1'
            }}
            >
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                    label='First Name'
                    name='firstName'
                    rules={[
                        {
                            required: true,
                            message: 'Please fill first name'
                        }
                    ]}
                    >
                        <Input size='large' />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                    label='Lastname'
                    name='lastName'
                    rules={[
                        {
                            required: true,
                            message: 'Please fill last name'
                        }
                    ]}
                    >
                        <Input size='large' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                    label='Email'
                    name='email'
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail',
                        },
                        {
                            required: true,
                            message: 'Please fill email'
                        }
                    ]}
                    >
                        <Input size='large' />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                    label='Phone'
                    name='phone'
                    rules={[
                        {
                            required: true,
                            message: 'Please fill phone',
                        },
                        {
                            len: 10,
                            max: 10,
                            message: 'Phone number must have 10 numbers'
                        }
                    ]}
                    >
                        <Input size='large' addonBefore={prefixSelector} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                    label='Address'
                    name='address'
                    rules={[
                        {
                            required: true,
                            message: 'Please fill address'
                        }
                    ]}
                    >
                        <Input size='large' />
                    </Form.Item>
                </Col>
            </Row>
            <Button type="primary" htmlType="submit" loading={loading}>
                Create
            </Button>
        </Form>
    }

    return (
        <div
        >
            {contextHolder}
            <CustomForm />
        </div>
    )
}

export default ForemanModal